export const TextAreaAutoResize = {
  mounted() {
    this.minHeight = this.el.dataset.minHeight || 80
    this.maxHeight = this.el.dataset.maxHeight || 200
    this.pushInputChanges = this.el.dataset.pushInputChanges == "true"

    this.autoResize()

    this.el.addEventListener("input", () => {
      this.autoResize()

      if (this.pushInputChanges) {
        this.el.dispatchEvent(new Event("change", { bubbles: true }))
      }
    })
  },

  updated() {
    this.autoResize()
  },

  autoResize() {
    this.el.style.height = "auto"
    const newHeight = Math.min(
      Math.max(this.el.scrollHeight, this.minHeight),
      this.maxHeight,
    )
    this.el.style.height = newHeight + "px"
    this.el.style.overflowY =
      this.el.scrollHeight > this.maxHeight ? "auto" : "hidden"
  },
}
